import React from "react";
import { Select, Tooltip } from "antd";
import { priceTypes } from "../../constants/memberPackageConstants";

const inputStyle = {
  width: "100px",
  padding: "4px 8px",
  fontSize: "14px",
  border: "1px solid #d9d9d9",
  borderRadius: "6px",
  outline: "none",
};

const subLabelStyle = {
  fontSize: "12px",
  color: "#595959",
  display: "block",
  marginBottom: "4px",
};

const PriceInput = ({
  price,
  onPriceChange,
  onTypeChange,
  viewMode = false,
  editChanges,
  stripeProductId,
}) => {
  const handleAmountChange = (e) => {
    let editChangesUpdated = editChanges;
    editChangesUpdated.productId = stripeProductId;
    let value = e.target.value;
    if (Number(value) >= 0) {
      if (value.includes(".") && value.length - value.indexOf(".") > 2) {
        value = value.slice(0, value.indexOf(".") + 3);
      }
      editChangesUpdated.priceChange = true;
      onPriceChange({ ...price, amount: Number(value) }, editChangesUpdated);
    }
  };

  const handleShippingChange = (e) => {
    let editChangesUpdated = editChanges;
    editChangesUpdated.productId = stripeProductId;
    let value = e.target.value;
    if (Number(value) >= 0) {
      editChangesUpdated.priceChange = true;
      if (value.includes(".") && value.length - value.indexOf(".") > 2) {
        value = value.slice(0, value.indexOf(".") + 3);
      }
      onPriceChange({ ...price, shipping: Number(value) }, editChangesUpdated);
    }
  };

  return (
    <div style={{ marginBottom: "24px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "12px" }}>
        <label style={{ marginBottom: 0, fontWeight: 500 }}>
          Price <span style={{ color: "red" }}>*</span>
        </label>
        <Tooltip
          placement="topLeft"
          title={() => (
            <div style={{ width: 400 }}>
              <p style={{ marginBottom: 0 }}>Per Member</p>
              <p>One price for all members. No discounts for couples/families. No children added separately.</p>
              <br />
              <p style={{ marginBottom: 0 }}>Per Adult</p>
              <p style={{ marginBottom: 0 }}>Allows a separate price for children.</p>
              <p>Child package does not allow Chant access. Only child&apos;s name is collected. A member number is assigned. Details are stored with parent account.</p>
              <br />
              <p style={{ marginBottom: 0 }}>Per Couple</p>
              <p>Provide a couples discount and separate price for children.</p>
              <br />
              <p style={{ marginBottom: 0 }}>Per Family</p>
              <p>One price for the entire family. Member prompted to select &apos;# of children&apos; at no additional cost.</p>
            </div>
          )}
        >
          <span className="border-0">
            <i className="fa fa-question-circle-o" style={{ color: "#8c8c8c", cursor: "pointer" }}></i>
          </span>
        </Tooltip>
      </div>

      <div style={{ display: "flex", gap: "20px", alignItems: "flex-end", flexWrap: "wrap" }}>
        <div>
          <span style={subLabelStyle}>Amount ($)</span>
          <input
            type="number"
            onChange={handleAmountChange}
            value={price.amount}
            className="no-arrow-field"
            style={inputStyle}
            onWheel={(e) => e.target.blur()}
          />
        </div>
        <div>
          <span style={subLabelStyle}>Price Type</span>
          <Select
            value={price.type}
            onChange={(value) => onTypeChange({ target: { value } })}
            disabled={viewMode}
            style={{ width: "160px" }}
            options={priceTypes.map((t) => ({ value: t, label: t }))}
          />
        </div>
        <div>
          <span style={subLabelStyle}>Shipping ($)</span>
          <input
            type="number"
            onChange={handleShippingChange}
            value={price.shipping}
            className="no-arrow-field"
            style={inputStyle}
            onWheel={(e) => e.target.blur()}
          />
        </div>
      </div>
    </div>
  );
};

export default PriceInput;
